import './App.css';
import { AppThemeProvider } from './features/theme/index';
import './translations/index';
import { OIDC_CONFIG } from './features/auth/data/auth-data';
import { AuthProvider } from 'react-oidc-context';
import AppRouter from './features/router/components/app-router';
import { useMediaQuery } from '@mui/material';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getPaletteMode, themeActions } from './features/theme/redux/theme-slice';
import { getLanguageLocale } from './services/language-service';
import { useAppDispatch } from './redux/hooks';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const App: React.FC = () => {
    const isDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
    const { i18n } = useTranslation();

    const locale = useMemo(() => getLanguageLocale(i18n.language), [i18n.language]);

    const dispatch = useAppDispatch();
    const queryClient = new QueryClient();

    useEffect(() => {
        dispatch(themeActions.setPaletteMode(getPaletteMode(isDarkMode)));
        dispatch(themeActions.setLocale(locale));
    }, []);

    return (
        <QueryClientProvider client={queryClient}>
            <AuthProvider {...OIDC_CONFIG}>
                <AppThemeProvider>
                    <AppRouter />
                </AppThemeProvider>
            </AuthProvider>
        </QueryClientProvider>
    );
};

export default App;
